<template>
    <div :class="alias + '-content content-body'" v-if="blockContent">
        <div v-if="blockContent.contentBlockTitle || blockContent.contentBlockSubtitle" :class="['content-title', {'subtitle-first': subtitleFirst}]">
            <template v-if="blockContent.contentBlockTitle">
                <h1 v-if="isPageTitle">{{ blockContent.contentBlockTitle }}</h1>
                <h2 v-else>{{ blockContent.contentBlockTitle }}</h2>
            </template>
            <template v-if="blockContent.contentBlockSubtitle" class="">
                <h2 v-if="isPageTitle">{{ blockContent.contentBlockSubtitle }}</h2>
                <h3 v-else>{{ blockContent.contentBlockSubtitle }}</h3>
            </template>
        </div>

        <div v-if="blockContent.markdownBody.html" v-html="getHtmlContent()" class="mb-4"></div>

        <template v-if="blockContent.additionalContent && blockContent.additionalContent.contentItems"
            v-for="content in blockContent.additionalContent.contentItems">

                <div class="row content-buttons" v-if="content.__typename == 'Buttons'">
                    <template v-for="(buttons, index) in content.buttonList.contentItems">
                        <div v-if="isValidLink(buttons.linkMenuItem.url)" class="col">
                            <a :href="formatContactLink(buttons.linkMenuItem.url)" class="btn btn-outline-dark text-uppercase rounded-0 py-2 d-flex align-items-center justify-content-center"
                                v-if="isAnchorLink(buttons.linkMenuItem.url)" :target="isExternalLink(buttons.linkMenuItem.url) ? '_blank' : ''">
                                {{ buttons.linkMenuItem.name }}
                            </a>
                            
                            <router-link v-else :to="buttons.linkMenuItem.url" class="btn btn-outline-dark text-uppercase rounded-0 py-2 d-flex align-items-center justify-content-center">
                                {{ buttons.linkMenuItem.name }}
                            </router-link>
                        </div>
                    </template>
                </div>
                <div class="content-images" v-else-if="content.__typename == 'Image' && content.images.urls && content.images.urls.length > 0">
                    <template v-for="(image, index) in content.images.urls">
                        <img v-if="content.images.urls != ''" class="img-fluid" :src="CmsBaseUrl() + image" alt="" />
                    </template>
                </div>
                <template v-else-if="content.__typename == 'ContentBlockFlowpart' && content.markdownBody.html">
                    <div class="position-relative content-block">
                        <div class="container-fluid container-lg py-5">
                            <ContentBlockFlowpart :content="content"></ContentBlockFlowpart>
                        </div>
                    </div>
                </template>
                <div class="row content-team-list pt-4" v-else-if="content.__typename == 'TeamList' && content.team && content.team.contentItems.length > 0">
                    <div class="col-sm col-lg-6 py-4" v-for="team in content.team.contentItems">
                        <div class="row team-member">
                            <div class="col-sm col-lg-6 py-lg-4">
                                <img v-if="team.image.urls.length > 0" :src="CmsBaseUrl() + team.image.urls[0]" class="img-fluid rounded-circle" :alt="team.displayText" />
                                <img v-else src="@/assets/about-us/team-member_0.png" class="rounded-circle" alt="">
                            </div>
                            <div class="col-sm col-lg-6 py-lg-4">
                                <h3>{{team.displayText}}</h3>
                                <p v-if="team.jobTitle" class="team-member-title">{{team.jobTitle}}</p>
                                <div v-html="team.bio.html"></div>
                            </div>
                        </div>
                    </div>
                </div>

        </template>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps({
        alias: {type: String, default: null},
        content: {type: Object, default: null},
        isPageTitle: {type: Boolean, default: false},
        subtitleFirst: {type: Boolean, default: false}
    })
    import ContentBlockFlowpart from "@/components/general/ContentBlockFlowpart.vue"
    import { ref, Ref, onMounted } from "vue"
    import { CmsBaseUrl } from "@/utils/functions"
    import { getContentBlock } from "@/utils/graphql"
    import { contentBlockObj } from '@/utils/graphql/contentblock'
    import { useApolloClient } from '@vue/apollo-composable'

    var blockContent: Ref<any | undefined> = ref(undefined)
    const { resolveClient } = useApolloClient()
    const ApolloClient = resolveClient()
    
    function isValidLink (url: String) {
        return url != null && url != ""
    }
    
    function isExternalLink (url: String) {
        return ["http", "mailto-", "tel-"].some(el => url.includes(el))
    }
    
    function isAnchorLink (url: String) {
        return url.includes('http')
    }
    
    function formatContactLink (url: String) {
        return url.replaceAll("mailto-", "mailto:").replaceAll("tel-", "tel:")
    }

    function getHtmlContent() {
        if(blockContent.value.markdownBody) {
            return blockContent.value.markdownBody.html.replaceAll("src=\"/media/" , `class=\"img-fluid\" src=\"${CmsBaseUrl()}/media/`)
        }
    }

    onMounted(async () => {
        if(props.alias != null) {
            await getContentBlock(ApolloClient, props.alias).then(res => {
                blockContent.value = res as contentBlockObj
            });
        }
        else if(props.content != null) {
            blockContent.value = props.content
        }
    })
</script>

<style scoped lang="scss">
    .content-title {
        :last-child {
            padding-bottom: 30px;
        }
    }
    .subtitle-first {
        display: flex;
        flex-direction: column;
        h1 + h2, h2 + h3 {
            order: -1;
        }
        :first-child {
            padding-bottom: 30px;
        }
        :last-child {
            padding-bottom: 0;
        }
    }

    .team-member {
    display: flex;
    margin:auto;
    }

    .team-member img{
        max-height: 100%;
        display: flex;
        margin:auto;
    }

    .team-member-title{
        font-size: larger;
        color: #3c3c3c;
        font-style: italic;
        font-weight: 600;
    }

    @media (max-width: 992px){
        .team-member h3{
        padding-top: 10px;
        text-align: center;
         }
        .team-member p{
            padding-left: 10px;
            padding-right: 10px;
            text-align: center;
        }
    }
</style>